import { CheckCircleFilled, CloseOutlined } from '@ant-design/icons';
import { notification } from 'antd';

import { colorConstants } from 'config/colorConstants';

import type { PackArchitectureExportScope } from './packArchitectureExport.helpers';

const EXPORT_SCOPE_LABEL: Record<PackArchitectureExportScope, string> = {
    current_view: 'current view',
    all_data: 'all data',
};

type PackArchitectureExportSuccessToastProps = {
    scope: PackArchitectureExportScope;
    onClose: () => void;
};

const PackArchitectureExportSuccessToast = ({ scope, onClose }: PackArchitectureExportSuccessToastProps) => (
    <div className="relative w-full p-6">
        <button
            type="button"
            aria-label="Close notification"
            className="absolute right-4 top-4 inline-flex h-4 w-4 items-center justify-center border-0 bg-transparent p-0"
            onClick={onClose}
        >
            <CloseOutlined style={{ fontSize: 12, color: colorConstants.greyAlt14 }} />
        </button>

        <div className="flex items-center gap-2 pr-6">
            <CheckCircleFilled style={{ fontSize: 22, color: colorConstants.notificationSuccess }} />
            <span
                className="text-base font-semibold leading-6"
                style={{ color: colorConstants.blackTransparent88 }}
            >
                Success
            </span>
        </div>

        <p
            className="mb-4 mt-2 text-sm leading-[22px]"
            style={{ color: colorConstants.blackTransparent88 }}
        >
            Data export for {EXPORT_SCOPE_LABEL[scope]} is ready! Download started automatically.
        </p>

        <div className="flex justify-end">
            <button
                type="button"
                className="border-0 bg-transparent p-0 text-sm font-medium leading-[22px]"
                style={{ color: colorConstants.purpleFont }}
                onClick={onClose}
            >
                Close
            </button>
        </div>
    </div>
);

export const showPackArchitectureExportSuccessNotification = (scope: PackArchitectureExportScope) => {
    const key = `pack-architecture-export-success-${Date.now()}`;
    const onClose = () => notification.close(key);

    notification.open({
        key,
        message: <PackArchitectureExportSuccessToast scope={scope} onClose={onClose} />,
        duration: 5,
        placement: 'topRight',
        closeIcon: false,
        className:
            'pack-architecture-export-success-notification shadow-axesDropdown [&_.ant-notification-notice]:!overflow-visible [&_.ant-notification-notice-message]:!m-0 [&_.ant-notification-notice-message]:!mb-0 [&_.ant-notification-notice-message]:!p-0',
        style: {
            width: 400,
            padding: 0,
            background: colorConstants.white,
            borderRadius: 8,
        },
    });
};
